/**
 * Re-implement indexedDB.cmp() for common types in JS for better performance
 */
function cmp(a, b) {
    var typeA = typeof a;
    var typeB = typeof b;
    if (isNaN(a) || isNaN(b)) {
        return indexedDB.cmp(a, b);
    }
    if (typeA === typeB) {
        if (typeA === 'number' || typeA === 'bigint') {
            return a - b;
        }
        if (typeA === 'string') {
            return strcmp(a, b);
        }
    }
    if (a instanceof Date && b instanceof Date) {
        return a.getTime() - b.getTime();
    }
    return indexedDB.cmp(a, b);
}
function strcmp(a, b) {
    return a < b ? -1 : +(a > b);
}
export default cmp;
//# sourceMappingURL=cmp.js.map